import type { Reducer } from 'redux';

import type {
  EditGroupSettingsFulfilledAction,
  NetworkGroupSettingsAction,
  NetworkGroupSettingsFulfilledAction,
} from '../../domains/networkGroupSettings/actions.types';
import type { NetworkGroupSettings } from '../types';

const loadNetworkGroupSettings = (
  state: NetworkGroupSettings,
  payload: NetworkGroupSettings,
  source: NetworkGroupSettingsFulfilledAction['meta']['source']
): NetworkGroupSettings => {
  if (!state?.hasPendingSensitivityLabelRequirementEdits || !payload) {
    return payload;
  }

  if (source === 'admin') {
    return {
      ...payload,
      hasPendingSensitivityLabelRequirementEdits: true,
    };
  }

  const hasServerAppliedSensitivityLabelRequirementEdits =
    payload.isSensitivityLabelRequiredForPublicGroups === state.isSensitivityLabelRequiredForPublicGroups &&
    payload.isSensitivityLabelRequiredForPrivateGroups === state.isSensitivityLabelRequiredForPrivateGroups;

  if (hasServerAppliedSensitivityLabelRequirementEdits) {
    return payload;
  }

  return {
    ...payload,
    isSensitivityLabelRequiredForPrivateGroups: state.isSensitivityLabelRequiredForPrivateGroups,
    isSensitivityLabelRequiredForPublicGroups: state.isSensitivityLabelRequiredForPublicGroups,
    hasPendingSensitivityLabelRequirementEdits: true,
  };
};

const editGroupSettings = (
  state: NetworkGroupSettings,
  payload: EditGroupSettingsFulfilledAction['payload']
): NetworkGroupSettings => {
  const updatedGroupSettings = payload.editGroupSettings?.settings;

  if (!state) {
    return state;
  }

  if (!updatedGroupSettings) {
    return state;
  }

  return {
    ...state,
    isSensitivityLabelRequired: updatedGroupSettings.isSensitivityLabelRequired,
    isSensitivityLabelRequiredForPrivateGroups: updatedGroupSettings.isSensitivityLabelRequiredForPrivateGroups,
    isSensitivityLabelRequiredForPublicGroups: updatedGroupSettings.isSensitivityLabelRequiredForPublicGroups,
    hasPendingSensitivityLabelRequirementEdits: true,
  };
};

const reducer: Reducer<NetworkGroupSettings, NetworkGroupSettingsAction> = (state = null, action) => {
  switch (action.type) {
    case 'NETWORK_GROUP_SETTINGS.FULFILLED':
      return loadNetworkGroupSettings(state, action.payload, action.meta.source);
    case 'EDIT_GROUP_SETTINGS.FULFILLED':
      return editGroupSettings(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
